import service from '@/utils/request'

/** 单文件上传到远程 OSS */
export function uploadFile(params) {
  return service.post('/oss/upload/remote', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000 // 设置超时2分钟
  })
}

/** 单文件上传到本地服务器 */
export function uploadToLocal(params) {
  return service.post('/oss/upload/local', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000 // 设置超时2分钟
  })
}

/** 多文件上传 */
export function multiUpload(params) {
  return service.post('/oss/multi-upload', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000 // 设置超时2分钟
  })
}

/** 文件删除 */
export function removeFile(params) {
  return service.get('/oss/remove', { params })
}
